import {
    PlusIcon,
    ShareIcon,
    ChevronLeftIcon,
    ChevronRightIcon
} from "@heroicons/react/24/solid";
import {
    CalendarDaysIcon
} from "@heroicons/react/24/outline";
import { useEffect, useState } from "react";
import SubGroupConversation from "./SubGroupConversation";
import { fetchAllSubGroups, listenToUpcomingEventsMainGroup } from "../../services/firestore/SGloopService";
import EventList from "./EventList";
import { useSearchParams } from "react-router-dom";




function SubGroups({ selected, handleBack, selectedSubGroup, setSelectedSubGroup }) {
    const [active, setActive] = useState("Sub-Communities");
    const [allSubGroups, setAllSubGroups] = useState([]);
    const [eventsData, setEventsData] = useState([]);
    const [searchParams] = useSearchParams();
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const tab = params.get("tab");

        if (tab === "Events" || tab === "Sub-Communities") {
            setActive(tab);
        }
    }, []);
    useEffect(() => {
        if (selected) {
            const fetchSubGroups = async () => {
                try {
                    const response = await fetchAllSubGroups(selected);
                    setAllSubGroups(response);

                    // ✅ Auto-select sub-group from URL if subId exists
                    const subIdFromUrl = searchParams.get("subId");
                    if (subIdFromUrl) {
                        const group = response.find(g => g.id === subIdFromUrl);
                        if (group) setSelectedSubGroup(group);
                    }

                } catch (error) {
                    console.error("Error fetching groups:", error);
                }
            };
            fetchSubGroups();

            // 🔑 subscribe to listener
            const unsubscribe = listenToUpcomingEventsMainGroup(selected, (data) => {
                setEventsData(data)
            });

            // 🔑 cleanup: unsubscribe when `selected` changes or component unmounts
            return () => {
                if (unsubscribe) unsubscribe();
            };
        }
    }, [selected])

    useEffect(() => {
        const handlePopState = () => {
            if (!selected) return; // no main group selected, nothing to do

            const params = new URLSearchParams(window.location.search);
            const subIdFromUrl = params.get("subId");

            if (subIdFromUrl) {
                const group = allSubGroups.find(g => g.id === subIdFromUrl);
                setSelectedSubGroup(group || null);
            } else {
                setSelectedSubGroup(null);
            }
        };

        window.addEventListener("popstate", handlePopState);

        return () => {
            window.removeEventListener("popstate", handlePopState);
        };
    }, [selected, allSubGroups]);

    const handleTabChange = (tab) => {
        setActive(tab);

        const params = new URLSearchParams(window.location.search);
        params.set("tab", tab);

        window.history.pushState({}, "", `${window.location.pathname}?${params.toString()}`);
    };


    return (
        <>
            <div className={`${selected ? 'block' : 'hidden'} ${selectedSubGroup ? 'hidden md:hidden' : 'block md:block'} md:w-2/3 overflow-y-auto`}>
                {selected ? (
                    <>
                        {/* Header Image Section */}
                        <div className="relative h-48 w-full">
                            {/* Background Image */}
                            <img
                                src={selected.image}
                                alt={selected.areaName}
                                className="absolute inset-0 w-full h-full object-cover opacity-60"
                            />
                            <div className="absolute inset-0 bg-black/40" />

                            {/* Top Buttons */}
                            <div className="absolute top-2 left-2 md:hidden z-20">
                                <button
                                    onClick={handleBack}
                                    className="text-white bg-black/40 px-2 py-1 rounded hover:bg-black/60"
                                >
                                    <ChevronLeftIcon className="h-6 w-6" />
                                </button>
                            </div>

                            <div className="absolute top-2 right-2 flex gap-2 z-10 mt-2">
                                {/* <button className="text-white bg-black/40 p-2 rounded-full hover:bg-black/60">
                                    <PlusIcon className="h-6 w-6" />
                                </button> */}
                                <button
                                    className="text-white bg-black/40 p-2 rounded-full hover:bg-black/60"
                                    onClick={() => {
                                        if (navigator.share) {
                                            navigator
                                                .share({
                                                    title: document.title,
                                                    url: window.location.href,
                                                })
                                                .catch((err) => console.error("Share failed:", err));
                                        } else {
                                            // fallback for browsers that don't support Web Share API
                                            navigator.clipboard.writeText(window.location.href);
                                            alert("URL copied to clipboard!");
                                        }
                                    }}
                                >
                                    <ShareIcon className="h-6 w-6" />
                                </button>
                            </div>

                            {/* Title */}
                            <div className="absolute bottom-4 left-4 z-10 text-white">
                                <div className="text-2xl font-bold">{selected.areaName}</div>
                                <div className="text-sm opacity-80">{selected.memberSubscription.length} Pax</div>
                            </div>
                        </div>

                        {/* Sub-groups Title */}
                        <div className="flex justify-center mt-6 mb-4">
                            <div className="flex w-4/5">
                                <button
                                    onClick={() => handleTabChange("Sub-Communities")}
                                    className={`flex-1 px-4 py-2 rounded-l-lg border border-gray-300 font-semibold text-sm sm:text-base ${active === "Sub-Communities"
                                        ? "bg-blue-600 text-white"
                                        : "bg-white text-gray-700 hover:bg-gray-100"
                                        }`}
                                >
                                    Sub-Communities
                                </button>
                                <button
                                    onClick={() => handleTabChange("Events")}
                                    className={`flex-1 px-4 py-2 rounded-r-lg border border-gray-300 font-semibold text-sm sm:text-base ${active === "Events"
                                        ? "bg-blue-600 text-white"
                                        : "bg-white text-gray-500 hover:bg-gray-100"
                                        }`}
                                >
                                    <span className="flex items-center justify-center gap-x-2">
                                        <CalendarDaysIcon className="w-4 h-4" />
                                        <span>{eventsData.length} Events</span>
                                    </span>
                                </button>
                            </div>
                        </div>
                        {/* Sub-group Rows */}
                        {active === "Sub-Communities" ?
                            <div className="px-4 space-y-4 pb-6">
                                {allSubGroups.map((group) => (
                                    <div
                                        key={group.id}
                                        className="flex items-center justify-between bg-white border rounded-lg shadow-sm px-4 py-3 hover:bg-gray-50"
                                        onClick={() => {
                                            setSelectedSubGroup(group)
                                            const params = new URLSearchParams(window.location.search);
                                            if (selected?.id) params.set("id", selected.id); // keep main group id
                                            params.set("subId", group.id); // add sub-group id
                                            const newUrl = `${window.location.pathname}?${params.toString()}`;
                                            window.history.pushState({ path: newUrl }, "", newUrl);
                                        }}
                                    >
                                        <div>
                                            <div className="font-semibold">
                                                {group.subGroupName} ({group.subMembershipSubscription?.length || 0})
                                            </div>
                                            <div className="text-sm text-gray-600">{group.description}</div>
                                        </div>
                                        <ChevronRightIcon className="text-gray-400 h-6 w-6" />
                                    </div>
                                ))}
                            </div> : null
                        }
                        {active == "Events" ? <EventList eventsData={eventsData} source={selectedSubGroup}></EventList> : null}
                    </>
                ) : (
                    <div className="text-gray-500 p-6">Select a conversation to view details.</div>
                )}
            </div>
            <SubGroupConversation selectedSubGroup={selectedSubGroup} mainLabel={selected} setSelectedSubGroup={setSelectedSubGroup}></SubGroupConversation>
        </>
    );
}

export default SubGroups;